export default {
    list: [{
            label: "Clientes",
            route: "",
            items: [{
                    label: "Visualizar",
                    route: "admin.clients"
                },
                {
                    label: "Consultorias",
                    route: "admin.consultings"
                }
            ],
            active: false
        },
        {
            label: "Legislação",
            route: "",
            items: [{
                    label: "Visualizar",
                    route: "admin.legislations"
                },
                {
                    label: "Categorias",
                    route: "admin.legislation-categories"
                }
            ],
            active: false
        },
        {
            label: "Conteúdo",
            route: "",
            items: [{
                    label: "Textos",
                    route: "admin.texts"
                },
                {
                    label: "Revistas",
                    route: "admin.magazines"
                },
                {
                    label: "Edições de Revistas",
                    route: "admin.editions"
                },
                {
                    label: "Autores",
                    route: "admin.authors"
                }
            ],
            active: false
        },
        {
            label: "Relatórios",
            route: "",
            items: [{
                    label: "Ranking de acessos",
                    route: "admin.report-text-access"
                },
                {
                    label: "Textos Acessados",
                    route: "admin.report-daily-text-access"
                },
                {
                    label: "Visitas ao Site",
                    route: "admin.report-system-access"
                }
            ],
            active: false
        },
        {
            label: "Comunicação",
            route: "",
            items: [{
                label: "Notícias",
                route: "admin.list-news"
            },
            {
                label: "Conteúdo das páginas",
                route: "admin.pages"
            }],
            active: false
        },
        {
            label: "Sistema",
            route: "",
            items: [{
                    label: "Usuários",
                    route: "admin.users"
                }, {
                    label: "Notificações",
                    route: "admin.notifications"
                },
                {
                    label: "Vendas online",
                    route: "",
                },
                {
                    label: "Erros e Melhorias",
                    route: "admin.errors",
                },
                {
                    label: "Meu perfil",
                    route: "",
                },
            ],
            active: false
        }
    ]
}